import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import {makeStyles, useTheme, withStyles} from "@mui/styles";
import ScreenLockPortraitTwoToneIcon from "@mui/icons-material/ScreenLockPortraitTwoTone";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import ChooseMobile from "./components/LoginWithToken/ChooseMobile";
import LoginUser from "./components/LoginWithToken/LoginUser";
import axios from "axios";
import { defaultVariables } from "../../../config";
import Grid from "@mui/material/Grid2";
import AppAnimate from "../../components/AppAnimate";
import {connect, getStore, setStore} from "trim-redux";
import AppCard from "../../components/layout/components/AppCard";
import {Styles} from "../../../config/design/styles";
import {useTranslation} from "react-i18next";
import LoginUserWithPass from "./components/LoginWithToken/LoginUserWithPass";
import Logo from "../../components/elements/Logo";
import Title from "../../components/elements/Title";
import {whereShouldGoAfterLogin} from "../../../config/values";



const LoginWithToken = ({classes}) => {

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const isAuth = getStore('isAuth');
    const [level, setLevel] = useState(1);
    const [user, setUser] = useState(null);
    const [withOTP, setWithOTP] = useState(false);
    const [wentOTP, setWentOTP] = useState(false);

    useEffect(() => {
        if (isAuth) {
            navigate(whereShouldGoAfterLogin());
        }
    }, [isAuth, navigate]);

    const makeLogin = (data) => {
        localStorage.setItem("ACT", data.accessToken);
        checkLogin();
    };

    const checkLogin = async () => {
        const loginToken = localStorage.getItem("ACT");

        if (loginToken) {
            try {
                const response = await axios.get(`${defaultVariables.url}/auth/check-login`, {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${loginToken}`,
                    },
                });
                setStore({
                    isAuth: true,
                    user: response.data,
                });
                if (response.data.first_name === null) {
                    navigate("/user-info");
                } else {
                    navigate(whereShouldGoAfterLogin());
                }
            } catch {

            }
        } else {

        }
    };

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('loginRegister')}>
            <div className={classes.authContentInner}>
                <AppCard
                    title={
                        <Logo old_logo parentStyle={{textAlign:"center",width:'100%'}} style={{width:150}}/>
                    }
                >
                    <Grid container spacing={2} justifyContent={"center"}>
                        <Grid item size={{xs:11}} style={{marginTop:20,marginBottom:30}}>
                            <Title color="field" align="left">{t("loginRegister")}</Title>
                            <Typography>{t("enterMobileNumber")}</Typography>
                        </Grid>

                            <Grid item size={{xs:11}}>
                            {level === 1 && (
                                <ChooseMobile
                                    hasBack
                                    setUser={setUser}
                                    setNextLevel={() => setLevel(level + 1)}
                                />
                            )}
                            {
                                (level === 2 && !!user) &&
                                    <>
                                    {
                                        (!!user.has_password && !withOTP) ?
                                            <LoginUserWithPass
                                                user={user}
                                                makeLogin={makeLogin}
                                                withOTP={withOTP}
                                                wentOTP={wentOTP}
                                                handleOtp={() => {
                                                    setWithOTP(true);
                                                    setWentOTP(true);
                                                }}
                                            />
                                            :
                                            <LoginUser
                                                user={user}
                                                makeLogin={makeLogin}
                                                has_password={user.has_password}
                                                handleOtp={() => setWithOTP(false)}
                                            />
                                    }
                                    </>

                            }
                        </Grid>
                    </Grid>
                </AppCard>
            </div>
        </AppAnimate>
    );
};
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(LoginWithToken));
